export const GAME_IDS = Object.freeze([
  'tank', 'tetris', 'snake', 'shooting', 'racing', 'breakout'
])

export const MAX_LEVEL = 10
export const TOP_N = 10
